window.addEventListener("DOMContentLoaded", function () {
  var geoEl = document.getElementById("header-geo-visibility");
  if (geoEl) {
    var visibleCountries = geoEl.getAttribute("data-visible-for") || "";
    if (
      visibleCountries && visibleCountries !== "All" &&
      typeof window.jQuery !== "undefined"
    ) {
      window.jQuery.getJSON("https://ipinfo.io/json", function (response) {
        if (visibleCountries.indexOf(response.country) !== -1) {
          document.querySelectorAll(".freeshiping").forEach(function (el) {
            el.style.opacity = 1;
          });
          document.querySelectorAll(".promo_banner").forEach(function (el) {
            el.style.opacity = 1;
          });
        } else {
          document.querySelectorAll(".promo_banner").forEach(function (el) {
            el.style.height = 0;
          });
          document.querySelectorAll(".promo_banner").forEach(function (el) {
            el.remove();
          });
        }
      });
    }
  }
});

var headerOffsetKey = window.innerWidth > 1365
  ? "jennen-header-offset-desktop"
  : "jennen-header-offset-mobile";

function readStoredHeaderOffset() {
  try {
    var raw = sessionStorage.getItem(headerOffsetKey);
    if (raw == null || raw === "") return null;
    var offset = parseInt(raw, 10);
    return isNaN(offset) ? null : offset;
  } catch (e) {
    return null;
  }
}

function applyHeaderOffset(offset) {
  document.documentElement.style.setProperty("--header-offset", offset + "px");
}

function getFixedHeaderEl() {
  if (window.innerWidth > 1365) {
    var desktop = document.querySelector(
      "[data-desktop-main-header].header-fixed--true",
    );
    if (desktop && !desktop.classList.contains("is-absolute")) {
      return desktop;
    }
    return null;
  }

  return document.querySelector("#header.mobile_nav-fixed--true");
}

function updatePageContentOffset() {
  var stored = readStoredHeaderOffset();
  if (stored != null) {
    applyHeaderOffset(stored);
    return;
  }

  if (!document.querySelector("#pagecontent")) return;

  var headerEl = getFixedHeaderEl();
  var offset = headerEl
    ? Math.ceil(headerEl.getBoundingClientRect().height)
    : 0;

  try {
    sessionStorage.setItem(headerOffsetKey, String(offset));
  } catch (e) {}

  applyHeaderOffset(offset);
}

updatePageContentOffset();
